import { createActions, createReducer } from 'reduxsauce';
import { schema } from 'normalizr';
import {
  EXTEND_NORMALIZED_INITIAL_STATE,
  FAVOURITE_ACTIONS_SET,
  PAGINATED_ACTIONS_SET,
  getRequestHandler,
  getExtendNormalized,
  getSuccessListHandler,
  getFailureHandler,
  softRemoveHandler,
  toggleFavourite,
} from '../../../store/structures';
import { types as detailsTypes } from '../details/duck';

const coupon = new schema.Entity('coupons');

export const { Types: types, Creators: actions } = createActions(
  {
    getAllList: ['params'],
    reloadCoupons: null,
    resetCouponList: null,
    ...PAGINATED_ACTIONS_SET,
    ...FAVOURITE_ACTIONS_SET,
  },
  { prefix: 'cb/coupons/all/' },
);

export const HANDLERS = {
  [types.REQUEST]: getRequestHandler(EXTEND_NORMALIZED_INITIAL_STATE),
  [types.SUCCESS]: getExtendNormalized(getSuccessListHandler, coupon),
  [types.SUCCESS_PAGINATED]: getExtendNormalized(
    getSuccessListHandler,
    coupon,
    { attach: true },
  ),
  [types.FAILURE]: getFailureHandler(),
  [detailsTypes.REMOVE_COUPON]: softRemoveHandler,
  [types.TOGGLE_FAVOURITE]: toggleFavourite,
  [types.RELOAD_COUPONS]: state => state,
  [types.RESET_COUPON_LIST]: () => EXTEND_NORMALIZED_INITIAL_STATE,
};

export default createReducer(EXTEND_NORMALIZED_INITIAL_STATE, HANDLERS);